import { render, staticRenderFns } from "./Vip.vue?vue&type=template&id=60e27ce9&scoped=true&"
import script from "./Vip.vue?vue&type=script&lang=js&"
export * from "./Vip.vue?vue&type=script&lang=js&"
import style0 from "./Vip.vue?vue&type=style&index=0&id=60e27ce9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e27ce9",
  null
  
)

export default component.exports